import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestScritturaManoEditComponent.vue?vue&type=template&id=7cb36ffe&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestScritturaManoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestScritturaManoEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestScritturaManoEditComponent.vue?vue&type=style&index=0&id=7cb36ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb36ffe",
  null
  
)

export default component.exports